import React from 'react';
import { AFFILIATE_COLORS, AFFILIATE_LABELS } from '@/lib/utils';
import { ArrowSquareOut } from '@phosphor-icons/react';

export default function AffiliateButton({ shop, url, size = 'md', testId }) {
  const label = AFFILIATE_LABELS[shop] || shop;
  const color = AFFILIATE_COLORS[shop] || 'bg-primary text-primary-foreground';
  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-5 py-3 text-base',
  };
  return (
    <a
      href={url}
      target="_blank"
      rel="nofollow sponsored noopener noreferrer"
      data-testid={testId || `affiliate-${shop}`}
      className={`inline-flex items-center justify-center gap-2 font-semibold rounded-sm transition-colors ${sizes[size]} ${color}`}
    >
      Bekijk bij {label}
      <ArrowSquareOut size={14} weight="bold" />
    </a>
  );
}
